import Img from '@admin/components/html/img'
import Image from '@admin/components/image'
import PropTypes from 'prop-types'
import React from 'react'

class Gallery extends React.Component {

  static contextTypes = {
    router: PropTypes.object
  }

  static propTypes = {
    attachable_type: PropTypes.string,
    attachable_id: PropTypes.number,
    images: PropTypes.array,
    onClick: PropTypes.func
  }

  static defaultProps = {
    onClick: () => {}
  }

  _handleClick = this._handleClick.bind(this)

  render() {
    const { images } = this.props
    return (
      <div className={`maha-gallery maha-gallery-${Math.min(images.length, 4)}`}>
        { images.map((image, index) => (
          <div className="maha-gallery-photo" key={`gallery_photo_${index}`} onClick={ this._handleClick.bind(this, image, index) }>
            <Image src={ image.asset.path } transforms={{ fit: 'cover', w: 300, h: 300 }} />
            <Img src={ `/images/services/${image.asset.source}.png` } className="maha-gallery-photo-source" />
          </div>
        ))}
      </div>
    )
  }

  _handleClick(image, index) {
    const { attachable_type, attachable_id } = this.props
    const { router } = this.context
    router.push(`/admin/${attachable_type}/${attachable_id}/attachments/${image.id}`)
  }

}

export default Gallery
